var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersona(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 82,
    viewBox: "0 0 77 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.3991 20.527C53.6836 30.1797 46.368 38.0541 38.337 38.0541C30.3059 38.0541 22.9776 30.1815 22.2749 20.527C21.5448 10.4855 28.6632 3 38.337 3C48.0107 3 55.1292 10.6681 54.3991 20.527Z",
    stroke: "#FAFAFA",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3359 49.5997C22.3245 49.5997 6.07389 58.4198 3.0667 75.0677C2.70414 77.0742 3.8415 78.9999 5.94507 78.9999H70.7267C72.8321 78.9999 73.9694 77.0742 73.6069 75.0677C70.5979 58.4198 54.3472 49.5997 38.3359 49.5997Z",
    stroke: "#FAFAFA",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersona);
export default __webpack_public_path__ + "static/media/persona.4e68b5b73dd31278e333e1e4999e364b.svg";
export { ForwardRef as ReactComponent };